import * as THREE from "three";

// renderer 기본 출력, 톤매핑, 픽셀 비율, 초기 사이즈, 그림자 활성화 등 초기 옵션 설정

export function createRenderer(container) {
  // WebGLRenderer 생성 (antialias: 계단현상 줄이기)
  const renderer = new THREE.WebGLRenderer({ antialias: true });

  // 출력 색공간: sRGB (현대 브라우저/모니터 표준 컬러)
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  // 톤매핑: ACES 필믹 (HDR → LDR 변환 시 영화 같은 톤)
  renderer.toneMapping = THREE.ACESFilmicToneMapping;

  // 픽셀 비율 설정: DPI 최적화 (최대 1.75배까지)
  renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 1.75));

  // 초기 사이즈: 컨테이너 크기에 맞춤
  renderer.setSize(container.clientWidth, container.clientHeight);

  // 그림자 활성화 (라이트/메시에서 castShadow, receiveShadow 별도 필요)
  renderer.shadowMap.enabled = true;

  // 생성된 canvas 엘리먼트를 컨테이너에 추가
  container.appendChild(renderer.domElement);

  return renderer;
}
